// Якорь пина раскрытого кластера («ромашки»): задаёт горизонтальную привязку балуна
// к гео-точке фичи. Значения совпадают со значением data-атрибута в вёрстке
// (BalloonManager) и с CSS-селекторами [data-anchor="..."] в styles.css —
// поэтому это строковый enum (ноль преобразований enum -> атрибут -> селектор).
export enum EClusterPinAnchor {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}

// Один слот сетки раскрытого кластера:
// - offset — смещение точки привязки от центра кластера в экранных пикселях [x вправо, y вниз];
// - anchor — какой край балуна привязывается к гео-точке (см. EClusterPinAnchor);
// - zIndex — порядок наложения внутри ромашки (z-order слоёв из дизайна, 0..count-1).
export type TClusterPin = {
  readonly offset: readonly [number, number];
  readonly anchor: EClusterPinAnchor;
  readonly zIndex: number;
};
